module.exports = __webpack_public_path__ + "static/img/game_bg_3.116eef93.png";